var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCheckComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_check_complete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.96,
    height: 25,
    viewBox: "0 0 24.96 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9943",
    "data-name": "Path 9943",
    d: "M12,0h1l.33.06c.47.05.94.08,1.4.17a12.29,12.29,0,0,1,7.65,4.71,12,12,0,0,1,2.48,6.18c0,.3.07.59.1.89v1a.94.94,0,0,0,0,.16c-.06.48-.08,1-.16,1.43a12.17,12.17,0,0,1-4.49,7.64,12.07,12.07,0,0,1-6.45,2.68L13,25H11.68c-.57-.08-1.15-.12-1.71-.23A12.27,12.27,0,0,1,2.57,20,12,12,0,0,1,.15,14.29C.09,13.86.05,13.42,0,13V12a.9.9,0,0,1,.05-.36c.06-.46.09-.94.17-1.4a12.24,12.24,0,0,1,3-6.07A12.27,12.27,0,0,1,11.1.1ZM10,15.17,8.78,13.88c-.77-.82-1.53-1.66-2.32-2.47a1.683,1.683,0,0,0-2.41,2.35l4.83,5.17.94,1,.17-.14,2.82-2.62L17.7,12.6c1-.9,1.94-1.8,2.9-2.71a1.684,1.684,0,0,0-2.3-2.46c-2.11,2-4.21,3.92-6.32,5.88Z",
    fill: "#00ba00",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9944",
    "data-name": "Path 9944",
    d: "M10,15.17l2-1.86c2.11-2,4.21-3.93,6.32-5.88a1.684,1.684,0,0,1,2.3,2.46c-1,.91-1.93,1.81-2.9,2.71l-4.89,4.57L10,19.79l-.17.14-.94-1L4.05,13.76a1.683,1.683,0,0,1,2.41-2.35c.79.81,1.55,1.65,2.32,2.47Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckComplete);
export default __webpack_public_path__ + "static/media/ic_check_complete.0f7c731a2baf906618dd41015dd7c8c9.svg";
export { ForwardRef as ReactComponent };